export const TOGGLE_ARCHIVE_MODAL_PROJECT = 'TOGGLE_ARCHIVE_MODAL_PROJECT';
export const SELECT_ARCHIVED_BOARD = 'SELECT_ARCHIVED_BOARD';
export const SET_FETCHING_ARCHIVED = 'SET_FETCHING_ARCHIVED';
